import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { LazyMotion, domAnimation } from 'framer-motion'
import './index.css'
import App from './App.tsx'

const Privacy = lazy(() => import('./pages/Privacy'))
const NotFound = lazy(() => import('./pages/NotFound'))
const Eldertons = lazy(() => import('./pages/Eldertons'))
const Planet = lazy(() => import('./pages/Planet'))
const NeonMap = lazy(() => import('./pages/NeonMap'))
const NeonMapDeck = lazy(() => import('./pages/NeonMapDeck'))

function PageFallback() {
  return (
    <div className="min-h-screen bg-[#1e232b] flex items-center justify-center text-white/70 font-sans">
      Loading…
    </div>
  )
}

function Router() {
  const path = window.location.pathname
  if (path === '/privacy' || path.startsWith('/privacy/')) {
    return (
      <Suspense fallback={<PageFallback />}>
        <Privacy />
      </Suspense>
    )
  }
  if (path.startsWith('/planet')) {
    return (
      <Suspense fallback={<PageFallback />}>
        <Planet />
      </Suspense>
    )
  }
  if (path.startsWith('/control-room') || path.startsWith('/coming-soon')) {
    return <App />
  }
  if (path.startsWith('/neonmap')) {
    return (
      <Suspense fallback={<PageFallback />}>
        <NeonMap />
      </Suspense>
    )
  }
  if (path.startsWith('/neonmap-deck')) {
    return (
      <Suspense fallback={<PageFallback />}>
        <NeonMapDeck />
      </Suspense>
    )
  }
  if (path.startsWith('/eldertons')) {
    return (
      <Suspense fallback={<PageFallback />}>
        <Eldertons />
      </Suspense>
    )
  }
  if (path !== '/' && path !== '') {
    return (
      <Suspense fallback={<PageFallback />}>
        <NotFound />
      </Suspense>
    )
  }
  return <App />
}

const rootEl = document.getElementById('root')!
const tree = (
  <StrictMode>
    <LazyMotion features={domAnimation} strict>
      <Router />
    </LazyMotion>
  </StrictMode>
)
// Always use createRoot to avoid hydration mismatch (#418). Prerendered HTML is still sent for SEO;
// React replaces it with an identical tree, avoiding client/server text mismatches.
createRoot(rootEl).render(tree)
